import React from 'react';
import loadable from '@loadable/component';

import { withError } from '../../../shared/components/error-boundary';

function IconMapper({ name, size }) {
    const Icon = loadable(() => import(`./${name}`));
    return <Icon size={size} />;
}

export default withError(IconMapper);
